import gtag, { install } from 'ga-gtag';
import { memo, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default memo(function GoogleAnalyticsPage({ children, siteId }) {

    const location = useLocation();
    const url = location.pathname + location.search

    // install adds google script to the head (only run once)
    useEffect(() => {
        if(siteId) {
            install(siteId)
        }
    }, [siteId]);

    // use gtag to set page events
    useEffect(() => {
        if(siteId) {
            gtag('set', 'page_path', url);
            gtag('event', 'page_view');
        }
    }, [siteId, url])

    return children;
});